
import { Component, Vue, Prop} from 'vue-property-decorator';
import CivilProceedingsSurvey from "./CivilProceedingsSurvey.vue";

import PageBase from "../../PageBase.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';

import { namespace } from "vuex-class";   
import "@/store/modules/application";

const applicationState = namespace("Application");

@Component({
    components:{
        CivilProceedingsSurvey,
        PageBase
    }
})
export default class BackgroundCivilCourtProceedings extends Vue {

    @Prop({required: true})
    step!: stepInfoType

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    dataReady = false;
    currentStep =0;
    currentPage =0;
    showTable = true;  
    civilProceedingsData = [];
    anyRowToBeEdited = null;
    editId = null; 
    incompleteError =  false; 
    
    courtProceedingsExist = 'n';    
    updated = 0;

    mounted(){
        Vue.nextTick(()=>this.surveyHasError());        
        this.reloadPageInformation();        
    }  

    public reloadPageInformation() {

        this.updated = 0;

        this.dataReady = false;  

        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage; 
        
        if (this.step.result?.backgroundCivilCourtProceedingsSurvey?.data) {

            const civilProceedingsInfo = this.step.result.backgroundCivilCourtProceedingsSurvey.data;   
            this.courtProceedingsExist = civilProceedingsInfo?.courtProceedingsExist?civilProceedingsInfo.courtProceedingsExist:'n';
            this.civilProceedingsData = civilProceedingsInfo.courtProceedings?civilProceedingsInfo.courtProceedings:[];             
        }        

        this.dataReady = true;
    }

    public situationChanged(){
        this.updated++;
    }
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('civil-proceedings-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public civilProceedingsComponentData(value) {       
        this.showTable = value;
    }

    public populateSurveyData(civilProceedingValue) {

        const currentIndexValue = this.civilProceedingsData?.length > 0 ? this.civilProceedingsData[this.civilProceedingsData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newCivilProceeding = { ...civilProceedingValue, id };
        this.civilProceedingsData = [...this.civilProceedingsData, newCivilProceeding];

        this.showTable = true; 
        this.resetCivilProceedingRelatedPages();
    }

    public deleteRow(rowToBeDeleted) {
       
        this.civilProceedingsData = this.civilProceedingsData.filter(data => {
            return data.id !== rowToBeDeleted;
        }); 
        this.resetCivilProceedingRelatedPages();
        this.surveyHasError();
    }

    public editRow(editedRow) {
        this.civilProceedingsData = this.civilProceedingsData.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
        this.surveyHasError();
        this.resetCivilProceedingRelatedPages();
    }

    public onPrev() {
       Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {       
       Vue.prototype.$UpdateGotoNextStepPage();       
    }

    public getCivilProceedingResults(){
        const questionResults: {name: string; value: any; title: string; inputType: string}[] =[];
        questionResults.push({name:'courtProceedingsExist', value: this.courtProceedingsExist == 'y'?'Yes':'No', title:'Have you been involved in court proceedings concerning any child in your care under any of the following legislation?', inputType:''})
        
        if(this.courtProceedingsExist == 'y'){
            for(const proceeding of this.civilProceedingsData)
            {
                questionResults.push({name:'proceedingInfoSurvey', value: this.getCivilProceedingInfo(proceeding), title:'Proceeding '+proceeding.id +' Information', inputType:''})
            }
        }        
        
        return {
            data: {
                courtProceedings: this.civilProceedingsData, 
                courtProceedingsExist: this.courtProceedingsExist
                
            },
            questions:questionResults, pageName:'Court Proceedings Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getCivilProceedingInfo(proceeding){
        const resultString = [];

        resultString.push(Vue.filter('styleTitle')("Party Name(s): ")+proceeding.partyNames);
        resultString.push(Vue.filter('styleTitle')("Court Location: ")+proceeding.courtLocation);

        let orderDates = '';

        if(proceeding.courtOrdersExist == 'y'){
            orderDates = '<ul>'
            for(const order of proceeding.courtOrderDates) {
                orderDates = orderDates+'<li>'+Vue.filter('beautify-date')(order.orderDate)+'</li>';
            }
            orderDates = orderDates+'</ul>'
        }        

        resultString.push(Vue.filter('styleTitle')("Order Dates: ")+orderDates)             
        
        return resultString
    }

    public resetCivilProceedingRelatedPages() {
    
        const p = this.stPgNo.GA;
        const pages = [
            p.Exhibits,
            p.ReviewYourAnswersGA
        ];
        Vue.filter('setProgressForPages')(p._StepNo, pages,50);    

    }

    public surveyHasError(){
        let progress = (this.courtProceedingsExist == 'y' && this.civilProceedingsData?.length == 0)? 50 : 100;
        this.incompleteError =  false;        
        for(const proceeding of this.civilProceedingsData){
            if (!proceeding.partyNames || 
                !proceeding.courtLocation || !proceeding.courtOrdersExist 
                || (proceeding.courtOrdersExist == 'y' && proceeding.courtOrderDates?.length == 0) ){            
                this.incompleteError = true;  
                progress = 50;    
                break
            }
        }        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }

    public isDisableNext() {
        return (this.courtProceedingsExist == 'y' && this.civilProceedingsData?.length == 0);
    }

    beforeDestroy() {
        this.surveyHasError();        
        this.UpdateStepResultData({step:this.step, data: {backgroundCivilCourtProceedingsSurvey: this.getCivilProceedingResults()}})       
    }
}
